import { isEmpty } from "../utils";
import { DATE_FORMAT } from "./common";

const countryDateFormats = [
  {
    countryName: "Albania",
    countryCode: "AL",
    iso: "ALB",
    format: "YYYY/MM/DD",
  },
  {
    countryName: "Andorra",
    countryCode: "AD",
    iso: "AND",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Argentina",
    countryCode: "AR",
    iso: "ARG",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Australia",
    countryCode: "AU",
    iso: "AUS",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Austria",
    countryCode: "AT",
    iso: "AUT",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Bahamas",
    countryCode: "BS",
    iso: "BHS",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Bahrain",
    countryCode: "BH",
    iso: "BHR",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Barbados",
    countryCode: "BB",
    iso: "BRB",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Belgium",
    countryCode: "BE",
    iso: "BEL",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Belize",
    countryCode: "BZ",
    iso: "BLZ",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Bermuda",
    countryCode: "BM",
    iso: "BMU",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Bosnia and Herzegovina",
    countryCode: "BA",
    iso: "BIH",
    format: "YYYY/MM/DD",
  },
  {
    countryName: "Brazil",
    countryCode: "BR",
    iso: "BRA",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Brunei Darussalam",
    countryCode: "BN",
    iso: "BRN",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Bulgaria",
    countryCode: "BG",
    iso: "BGR",
    format: "YYYY/MM/DD",
  },
  {
    countryName: "Cambodia",
    countryCode: "KH",
    iso: "KHM",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Canada",
    countryCode: "CA",
    iso: "CAN",
    format: "MM/DD/YYYY",
  },
  { countryName: "Chile", countryCode: "CL", iso: "CHL", format: "DD/MM/YYYY" },
  { countryName: "China", countryCode: "CN", iso: "CHN", format: "YYYY/MM/DD" },
  {
    countryName: "Columbia",
    countryCode: "CO",
    iso: "COL",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Croatia",
    countryCode: "HR",
    iso: "HRV",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Czech Republic",
    countryCode: "CZ",
    iso: "CZE",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Denmark",
    countryCode: "DK",
    iso: "DNK",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Ecuador",
    countryCode: "EC",
    iso: "ECU",
    format: "DD/MM/YYYY",
  },
  { countryName: "Egypt", countryCode: "EG", iso: "EGY", format: "DD/MM/YYYY" },
  {
    countryName: "El Salvador",
    countryCode: "SV",
    iso: "SLV",
    format: "MM/DD/YYYY",
  },
  {
    countryName: "Estonia",
    countryCode: "EE",
    iso: "EST",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "F.Y.R.O.M. (Macedonia)",
    countryCode: "MK",
    iso: "MKD",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Finland",
    countryCode: "FI",
    iso: "FIN",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "France",
    countryCode: "FR",
    iso: "FRA",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Germany",
    countryCode: "DE",
    iso: "DEU",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Greece",
    countryCode: "GR",
    iso: "GRC",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Guatemala",
    countryCode: "GT",
    iso: "GTM",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Hong Kong",
    countryCode: "HK",
    iso: "HKG",
    format: "yyyy年MM月dd日",
  },
  {
    countryName: "Hungary",
    countryCode: "HU",
    iso: "HUN",
    format: "YYYY/MM/DD",
  },
  {
    countryName: "Iceland",
    countryCode: "IS",
    iso: "ISL",
    format: "DD/MM/YYYY",
  },
  { countryName: "India", countryCode: "IN", iso: "IND", format: "DD/MM/YYYY" },
  {
    countryName: "Indonesia",
    countryCode: "ID",
    iso: "IDN",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Ireland",
    countryCode: "IE",
    iso: "IRL",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Israel",
    countryCode: "IL",
    iso: "ISR",
    format: "MM/DD/YYYY",
  },
  { countryName: "Italy", countryCode: "IT", iso: "ITA", format: "DD/MM/YYYY" },
  { countryName: "Japan", countryCode: "JP", iso: "JPN", format: "YYYY/MM/DD" },
  { countryName: "Kenya", countryCode: "KE", iso: "KEN", format: "DD/MM/YYYY" },
  { countryName: "Laos", countryCode: "LA", iso: "LAO", format: "DD/MM/YYYY" },
  {
    countryName: "Latvia",
    countryCode: "LV",
    iso: "LVA",
    format: "YYYY/DD/MM",
  },
  {
    countryName: "Liechtenstein",
    countryCode: "LI",
    iso: "LIE",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Lithuania",
    countryCode: "LT",
    iso: "LTU",
    format: "YYYY/MM/DD",
  },
  {
    countryName: "Luxembourg",
    countryCode: "LU",
    iso: "LUX",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Malaysia",
    countryCode: "MY",
    iso: "MYS",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Mexico",
    countryCode: "MX",
    iso: "MEX",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Monaco",
    countryCode: "MC",
    iso: "MCO",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Montenegro",
    countryCode: "ME",
    iso: "MNE",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Mozambique",
    countryCode: "MZ",
    iso: "MOZ",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Myanmar",
    countryCode: "MM",
    iso: "MMR",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Netherlands",
    countryCode: "NL",
    iso: "NLD",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "New Zealand",
    countryCode: "NZ",
    iso: "NZL",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "North Korea",
    countryCode: "KP",
    iso: "PRK",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Norway",
    countryCode: "NO",
    iso: "NOR",
    format: "DD/MM/YYYY",
  },
  { countryName: "Oman", countryCode: "OM", iso: "OMN", format: "DD/MM/YYYY" },
  {
    countryName: "Pakistan",
    countryCode: "PK",
    iso: "PAK",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Panama",
    countryCode: "PA",
    iso: "PAN",
    format: "MM/DD/YYYY",
  },
  {
    countryName: "Papua New Guinea",
    countryCode: "PG",
    iso: "PNG",
    format: "DD/MM/YYYY",
  },
  { countryName: "Peru", countryCode: "PE", iso: "PER", format: "DD/MM/YYYY" },
  {
    countryName: "Philippines",
    countryCode: "PH",
    iso: "PHL",
    format: "MM/DD/YYYY",
  },
  {
    countryName: "Poland",
    countryCode: "PL",
    iso: "POL",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Portugal",
    countryCode: "PT",
    iso: "PRT",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Puerto Rico",
    countryCode: "PR",
    iso: "PRI",
    format: "MM/DD/YYYY",
  },
  {
    countryName: "Romania",
    countryCode: "RO",
    iso: "ROM",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Russian Federation",
    countryCode: "RU",
    iso: "RUS",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Saudi Arabia",
    countryCode: "SA",
    iso: "SAU",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Serbia",
    countryCode: "RS",
    iso: "SRB",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Singapore",
    countryCode: "SG",
    iso: "SGP",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Slovak Republic",
    countryCode: "SK",
    iso: "SVK",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Slovenia",
    countryCode: "SI",
    iso: "SVN",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "South Africa",
    countryCode: "ZA",
    iso: "ZAF",
    format: "DD/MM/YYYY",
  },
  { countryName: "Korea", countryCode: "KR", iso: "KOR", format: "YYYY/MM/DD" },
  { countryName: "Spain", countryCode: "ES", iso: "ESP", format: "DD/MM/YYYY" },
  {
    countryName: "Sweden",
    countryCode: "SE",
    iso: "SWE",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Switzerland",
    countryCode: "CH",
    iso: "CHE",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Taiwan",
    countryCode: "TW",
    iso: "TWN",
    format: "YYYY/MM/DD",
  },
  {
    countryName: "Thailand",
    countryCode: "TH",
    iso: "THA",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Turkey",
    countryCode: "TR",
    iso: "TUR",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "United Arab Emirates",
    countryCode: "AE",
    iso: "ARE",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "United Kingdom",
    countryCode: "UK",
    iso: "GBR",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "United States of America",
    countryCode: "US",
    iso: "USA",
    format: "MM/DD/YYYY",
  },
  {
    countryName: "Venezuela",
    countryCode: "VE",
    iso: "VEN",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Vietnam",
    countryCode: "VN",
    iso: "VNM",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Virgin Islands",
    countryCode: "VI",
    iso: "VIR",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Slovakia",
    countryCode: "100",
    iso: null,
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Bermuda",
    countryCode: "B3",
    iso: null,
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Brunei",
    countryCode: "BI",
    iso: "BDI",
    format: "DD/MM/YYYY",
  },
  { countryName: "Burma", countryCode: "BU", iso: null, format: "DD/MM/YYYY" },
  {
    countryName: "Cambodia",
    countryCode: "CM",
    iso: "CMR",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "England",
    countryCode: "GB",
    iso: "GBR",
    format: "DD/MM/YYYY",
  },
  { countryName: "Korea", countryCode: "KO", iso: "KOR", format: "DD/MM/YYYY" },
  { countryName: "Macau", countryCode: "MO", iso: "MAC", format: "DD/MM/YYYY" },
  {
    countryName: "North Korea",
    countryCode: "NK",
    iso: null,
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Papua New Guinea",
    countryCode: "PN",
    iso: "PCN",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Sri Lanka",
    countryCode: "SL",
    iso: "SLE",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Vietnam",
    countryCode: "VT",
    iso: null,
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Russia",
    countryCode: "RU",
    iso: "RUS",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "United Arab Emirates",
    countryCode: "AE",
    iso: "ARE",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Colombia",
    countryCode: "CO",
    iso: "COL",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Kazakhstan",
    countryCode: null,
    iso: null,
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Serbia and Montenegro",
    countryCode: "CS",
    iso: null,
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Algeria",
    countryCode: "DZ",
    iso: "DZA",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Armenia",
    countryCode: "AM",
    iso: "ARM",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Bangladesh",
    countryCode: "BD",
    iso: "BGD",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Belarus",
    countryCode: "BY",
    iso: "BLR",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Bolivia",
    countryCode: "BO",
    iso: "BOL",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Cayman Islands",
    countryCode: "KY",
    iso: "CYM",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Cyprus",
    countryCode: "CY",
    iso: "CYP",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Georgia",
    countryCode: "GE",
    iso: "GEO",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Greenland",
    countryCode: "GL",
    iso: "GRL",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Gibraltar",
    countryCode: "GI",
    iso: "GIB",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Jamaica",
    countryCode: "JM",
    iso: "JAM",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Jordan",
    countryCode: "JO",
    iso: "JOR",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Kuwait",
    countryCode: "KW",
    iso: "KWT",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Lebanon",
    countryCode: "LB",
    iso: "LBN",
    format: "DD/MM/YYYY",
  },
  { countryName: "Malta", countryCode: "MT", iso: "MLT", format: "DD/MM/YYYY" },
  {
    countryName: "Moldova",
    countryCode: "MD",
    iso: "MDA",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Morroco",
    countryCode: "MA",
    iso: "MAR",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Neth. Antilles",
    countryCode: "AN",
    iso: null,
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Nigeria",
    countryCode: "NG",
    iso: "NGA",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Paraquay",
    countryCode: "PY",
    iso: "PRY",
    format: "DD/MM/YYYY",
  },
  { countryName: "Qatar", countryCode: "QA", iso: "QAT", format: "DD/MM/YYYY" },
  {
    countryName: "San Marino",
    countryCode: "SM",
    iso: "SMR",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Slovakia",
    countryCode: "SK",
    iso: "SVK",
    format: "DD/MM/YYYY",
  },
  { countryName: "Syria", countryCode: "SY", iso: "SYR", format: "DD/MM/YYYY" },
  {
    countryName: "Tunisia",
    countryCode: "TN",
    iso: "TUN",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Ukraine",
    countryCode: "UA",
    iso: "UKR",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Uruguay",
    countryCode: "UY",
    iso: "URY",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Vatican City",
    countryCode: "VA",
    iso: "VAT",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Senegal",
    countryCode: "SN",
    iso: "SEN",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Kazakhstan",
    countryCode: "KZ",
    iso: "KAZ",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Costa Rica",
    countryCode: "CR",
    iso: "CRI",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Tanzania",
    countryCode: "TZ",
    iso: null,
    format: "DD/MM/YYYY",
  },
  { countryName: "Angola", countryCode: "AO", iso: null, format: "DD/MM/YYYY" },
  {
    countryName: "Botswana",
    countryCode: null,
    iso: null,
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Cameron",
    countryCode: null,
    iso: "CMR",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Cote d'Ivoire",
    countryCode: null,
    iso: null,
    format: "DD/MM/YYYY",
  },
  { countryName: "Gambia", countryCode: null, iso: null, format: "DD/MM/YYYY" },
  { countryName: "Ghana", countryCode: "GH", iso: null, format: "DD/MM/YYYY" },
  {
    countryName: "Mauritius",
    countryCode: "MU",
    iso: null,
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Sierra Leone",
    countryCode: null,
    iso: null,
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Uganda",
    countryCode: null,
    iso: "UGA",
    format: "DD/MM/YYYY",
  },
  { countryName: "Zambia", countryCode: null, iso: null, format: "DD/MM/YYYY" },
  {
    countryName: "Zimbabwe",
    countryCode: null,
    iso: null,
    format: "DD/MM/YYYY",
  },
  { countryName: "Nepal", countryCode: null, iso: null, format: "DD/MM/YYYY" },
  {
    countryName: "SriLanka",
    countryCode: null,
    iso: null,
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Honduras",
    countryCode: null,
    iso: null,
    format: "MM/DD/YYYY",
  },
  {
    countryName: "Dominican Republic",
    countryCode: null,
    iso: null,
    format: "MM/DD/YYYY",
  },
  {
    countryName: "Azerbaijan",
    countryCode: null,
    iso: null,
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Kyrgyzstan",
    countryCode: null,
    iso: null,
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Trinidad and Tobago",
    countryCode: null,
    iso: null,
    format: "DD/MM/YYYY",
  },
  { countryName: "Chad", countryCode: "TD", iso: null, format: "DD/MM/YYYY" },
  { countryName: "Congo", countryCode: "CG", iso: null, format: "DD/MM/YYYY" },
  { countryName: "Gabon", countryCode: "GA", iso: null, format: "DD/MM/YYYY" },
  {
    countryName: "Madagascar",
    countryCode: "MG",
    iso: null,
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Seychelles",
    countryCode: "SC",
    iso: null,
    format: "DD/MM/YYYY",
  },
  {
    countryName: "Global",
    countryCode: "GLB",
    iso: "GLB",
    format: "DD/MM/YYYY",
  },
  {
    countryName: "LATAM-ES",
    countryCode: "LE",
    iso: null,
    format: "DD/MM/YYYY",
  },
  { countryName: "APME", countryCode: "AP", iso: null, format: "DD/MM/YYYY" },
];

export const getDateFormatByCountry = (
  countryCode: string,
): string | undefined => {
  if (isEmpty(countryCode)) {
    return DATE_FORMAT.DD_MM_YYYY_SLASH;
  }
  const country = countryDateFormats.find(
    (c) =>
      c.countryCode?.trim().toLowerCase() === countryCode.trim().toLowerCase(),
  );
  return country ? country.format : DATE_FORMAT.DD_MM_YYYY_SLASH;
};

export const getDateFormatByCountryWithTime = (
  countryCode: string,
): string | undefined => {
  return getDateFormatByCountry(countryCode) + " | HH:mm A";
};
